import {createSimpleAction, createTypeAction} from "../utils/actionUtils";

export const EMIT_NOTIFICATION = 'EMIT_NOTIFICATION'
export const emitNotificationAction = createSimpleAction(EMIT_NOTIFICATION, 'notification')

export const CLEAR_ACTIVE_NOTIFICATION = 'CLEAR_ACTIVE_NOTIFICATION'
export const clearActiveNotificationAction = createTypeAction(CLEAR_ACTIVE_NOTIFICATION)